<template>
  <el-popover placement="bottom-start" width="200" trigger="click" transition="el-zoom-in-top" class="ips-org-tree"
    popper-class="ips-org-tree__popper" v-model="visible" @hide="handleHide">
    <div class="ips-org-tree__tree-container" ref="tree-container">
      <el-tree ref="hrOrgTree" :data="treeData" lazy :load="loadOrg" :show-checkbox="showCheckbox"
        :check-strictly="checkStrictly" node-key="id" :filter-node-method="filterNode"
        :default-expanded-keys="defaultExpandedKeys" :default-checked-keys="defaultCheckedKeys" :props="defaultProps"
        @node-click="handleNodeClick" @check-change="handleCheckChange"></el-tree>
    </div>
    <el-input slot="reference" v-model.trim="name" :clearable="true" :readonly="readonly" class="ips-org-tree__input"
      :placeholder="placeholder" :suffix-icon="iconShow && readonly ? false : 'el-icon-arrow-down'" @change="handleChange"
      @input="handleInput" @blur="handleBlur" @focus="handleFocus" @click.native="handleClick" @mouseleave.native="leave"
      @mouseenter.native="enter">
      <span slot="suffix" v-if="readonly">
        <i class="el-icon-circle-close" v-show="iconShow" @click.stop="clearDataByIcon"
          style="margin-left: 200px;cursor: pointer;" />
      </span>
    </el-input>
  </el-popover>
</template>

<script>
import { utils } from "@/components"
export default {
  props: {
    value: [Object, String],
    orgName: { type: String, default: '' },
    // 禁用的数据
    orgRevert: { type: Array, default: () => [] },
    // 是否需要检测哪些组织机构被禁用
    isCheckForbid: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    deptId: { type: String, default: '' },
    defaultCheckData: { type: Array, default: () => [] },
    defaultExpandedKeys: Array,
    defaultCheckedKeys: Array,
    showCheckbox: Boolean,
    checkStrictly: Boolean,
    /**
     * 是否包行半选状态的节点
     */
    hasHalfChecked: { type: Boolean, default: false },
    /**
     * 仅返回叶节点数据
     */
    onlyLeafChecked: { type: Boolean, default: false },
    selectFull: { type: Boolean, default: false },
    placeholder: String,
    onlyValue: [String, Number],
    id: [String, Number],
    width: {
      default: 200
    },
    /***'
     * 对应orgKindId: ogn,dpt,pos,psm
     * 和typeSign： 3，5,7,9
     *
     * */
    filterLevel: String,
    selectLevel: String,
    /**
     * 针对不通过树传递不同的url,但是要求server端返回的数据必须符合下列格式
     * {id:"", parentId:"", name:"", children:"", childrens:[]}
     */
  },
  model: {
    prop: 'defaultCheckData',
    event: 'changeCheck'
  },
  data() {
    return {
      name: "",
      oldName: "",
      treeData: [],
      selectNodes: [],
      rootResolve: "",
      rootNode: {},
      visible: false,
      iconShow: false,
      rootData: [{
        typeName: "全部",
        id: "0",
        hasChildren: true,
        orgKindId: "dpt",
        fictitiousFullName: '/全部'
      }],
      defaultProps: {
        label: 'typeName',
        children: 'businessmanTypeViewList',
        isLeaf: leaf => !leaf
      }
    };
  },
  created() {
    // 文本框的默认值
    this.name = this.orgName;
  },
  watch: {
    visible(newVal) {
      if (!newVal)
        this.$emit("up", this.selectNodes);
    },
    orgName(value) {
      this.name = value;
    },
    value(value) {
      if (utils.isEmpty(value)) this.name = ""
    }
  },
  methods: {
    leave() {
      this.iconShow = false
    },
    enter() {
      this.iconShow = true
    },
    clearDataByIcon() {
      if (this.showCheckbox) {
        this.$emit("update:name", "");
        this.$emit("input", []);
        this.$emit("change", []);
        this.setCheckedKeys([]);
      } else {
        this.$emit("update:name", "");
        this.$emit("changeCheck", '');
        this.$emit("change", '');
      }
      this.name = ""
    },
    reLoadOrg() {
      this.treeData = [];
      this.loadOrg(this.rootNode, this.rootResolve);
    },
    // { level, data }
    loadOrg(node, resolve) {
      if (node.level === 0) {
        this.rootNode = node
        this.rootResolve = resolve
        if (this.showCheckbox && this.isCheckForbid && this.orgRevert.indexOf(this.rootData[0].id) > -1) this.rootData.disabled = true;
        this.treeData = [...this.rootData]
      } else {
        this.$store.dispatch("businessConfig/loadingTree", {
          parentId: node.data.id,
          checked: false,
        }).then(result => {
          if (this.showCheckbox && this.isCheckForbid) {
            result = result.map((item) => {
              if (this.orgRevert.indexOf(item.id) > -1) item.disabled = true;
              return item
            })
          }
          resolve(result);
          if (this.showCheckbox) this.setCheckedKeys(this.defaultCheckData.concat(this.orgRevert))
        })
          .catch(() => {
            resolve();
          })
      }
    },
    handleHide() {
    },
    setCheckedKeys(keys) {
      this.$refs["hrOrgTree"].setCheckedKeys(keys, this.onlyLeafChecked);
    },
    setCheckedNodes(nodes) {
      this.$refs["hrOrgTree"].setCheckedNodes(nodes, this.onlyLeafChecked);
    },
    handleChange(val) {
      this.$refs["hrOrgTree"].filter(val);
      if (!val) {
        this.$refs["hrOrgTree"].setCheckedNodes([]);
      }
    },
    handleClick() {
      this.$refs["hrOrgTree"].filter("")
    },
    handleNodeClick(data) {
      // 多选情况不响应点击事件
      if (this.showCheckbox) return
      if (data.id == "0") return//根节点不可选
      this.name = data.typeName;
      if (this.selectFull) {
        this.$emit("changeCheck", data.fictitiousFullName)
        this.$emit('change', data.fictitiousFullName)
      } else {
        this.$emit("changeCheck", data.id)
        this.$emit('change', data.id)
      }
      this.visible = false;
    },
    handleCheckChange(value, checked) {
      if (this.showCheckbox) {
        if (!checked) {
          this.defaultCheckData = this.defaultCheckData.filter((item) => item != value.id);
        }
        let nodes = this.$refs["hrOrgTree"].getCheckedNodes();
        nodes = nodes.filter((item) => !item.disabled)
        this.name = nodes.map(node => node.typeName).join(",")
        let orgIds = nodes.map(node => node.id);
        this.$emit("changeCheck", this.defaultCheckData.concat(orgIds.filter((val) => { return !(this.defaultCheckData.indexOf(val) > -1) })))
        this.$emit("update:name", this.name);
        this.$emit("input", orgIds);
        this.$emit("change", nodes);
      }
    },
    handleInput() {
      this.visible = true;
      this.$refs["hrOrgTree"].filter(this.name);
    },
    handleBlur() {
      if (this.showCheckbox) {
        let nodes = (this.selectNodes = this.$refs.hrOrgTree.getCheckedNodes(this.onlyLeafChecked));
        this.name = nodes.map(item => item.name).join(",");
      }
      // 如果用户没有输入新节点，则把原来选择的节点名称显示回来。
      if (utils.isEmpty(this.name)) this.name = this.oldName;
    },
    handleFocus() {
      this.oldName = this.name;
      this.name = "";
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    /**
     * hasHalfChecked
     * 是否包行半选状态的节点
     *
     * onlyLeafChecked
     * 仅返回叶节点数据
     */
    getCheckedNodes(onlyLeafChecked, hasHalfChecked) {
      return this.$refs["hrOrgTree"].getCheckedNodes(onlyLeafChecked, hasHalfChecked);
    }
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/dropTree.scss";
</style>
